export default __webpack_public_path__ + "static/media/edit.291a2f2c.svg";